import React from 'react';
import { Header, Body } from './components';


const QuickCodes = () => {
  window.scrollTo(0, 0)
  return (
    <div>
      <Header />
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '2vh' }} />
      <Body />
    </div>
  );
};


export default QuickCodes;